import React from 'react';
import { ROUTE_NAMES } from '../../Routes';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import PressSection from '../../Components/PressSection';
// import GetInTouchSection from '../../Components/GetInTouchSection';
// import StayConnected from '../../Components/StayConnectedSection';

// Blog images
import P_1 from '../../assets/press/Press-1-1.png';
import P_2 from '../../assets/press/Press-2-1.webp';
import P_3 from '../../assets/press/Press-3-1.jpg';
import P_4 from '../../assets/press/Press-5-1.jpg';
import P_5 from '../../assets/press/Press-6-1.jpg';
import P_6 from '../../assets/press/Press-7-1.webp';
import P_7 from '../../assets/press/Press-8-1.jpg';
import P_8 from '../../assets/press/21-Hollywood.jpg';
import P_9 from '../../assets/press/1H_41-Foto-3-860x485.jpg';
import P_10 from '../../assets/press/Press-10-1.jpg';
import P_11 from '../../assets/press/Press-11-1.webp';
import P_12 from '../../assets/press/Press-12-1.webp';

export default function Press() {
	const location = useLocation();
	const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

	const presses = [
		{
			name: 'Construction Starts on ’21 Hollywood’ at 2100 N. Federal Highway, Hollywood, FL, 33020',
			writenBy: 'Colt Dodd',
			image: P_1,
			link: ROUTE_NAMES.PRESS1,
		},
		{
			name: '21 Hollywood, a new 13-story mixed-use apartment development is coming to the heart of Hollywood',
			writenBy: 'Jake Nicholas',
			image: P_2,
			link: ROUTE_NAMES.PRESS2,
		},
		{
			name: 'Exclusive & Iconic: Starlife Group’s 21 Hollywood Recognized as the Best in Luxury Real Estate',
			writenBy: 'Totalprestige Magazine',
			image: P_3,
			link: ROUTE_NAMES.PRESS3,
		},
		{
			name: 'The Future of Luxury Real Estate: An Exclusive Interview with Gevorg Shahbazyan, Visionary Founder of Starlife Group',
			writenBy: 'Luxury Lifestyle Awards',
			image: P_4,
			link: ROUTE_NAMES.PRESS4,
		},
		{
			name: 'Starlife Group Founder and CEO Gevorg Shahbazyan Named Young Developer of the Year at the Red Awards Florida 2025',
			writenBy: 'Daylight Time',
			image: P_5,
			link: ROUTE_NAMES.PRESS5,
		},
		{
			name: 'Bardi VP & Starlife Receive Green Light for 200-unit Apartment Project in Hollywood, FL',
			writenBy: 'Traded Media',
			image: P_6,
			link: ROUTE_NAMES.PRESS6,
		},
		{
			name: 'Luxury at its finest: 21 Hollywood by Starlife Group wins prestigious industry award',
			writenBy: 'LLM Reporters',
			image: P_7,
			link: ROUTE_NAMES.PRESS7,
		},
		{
			name: 'Starlife Group Building Hollywood Apartment Project',
			writenBy: 'Mike Boyd',
			image: P_8,
			link: ROUTE_NAMES.PRESS8,
		},
		{
			name: 'First Concrete Poured As Construction Progresses On 21 Hollywood',
			writenBy: 'Lisa Hay',
			image: P_9,
			link: ROUTE_NAMES.PRESS9,
		},
		{
			name: 'Foundation Work Progresses on 21 Hollywood at 2100 N. Federal Highway in Hollywood, Florida.',
			writenBy: 'Oscar Nunez',
			image: P_10,
			link: ROUTE_NAMES.PRESS10,
		},
		{
			name: 'The Urban Blueprint Rewritten: 21 Hollywood by Starlife Group',
			writenBy: 'Sylvester',
			image: P_11,
			link: ROUTE_NAMES.PRESS11,
		},
		{
			name: 'The Urban Blueprint Rewritten: 21 Hollywood by Starlife Group',
			writenBy: 'Apnews',
			image: P_12,
			link: ROUTE_NAMES.PRESS12,
		},
	];

	return (
		<div className='press-page blogs-page'>
			<Helmet>
				<title>Starlife: Press</title>
				<meta
					name='description'
					content='Stay updated with Starlife Group’s latest news, real estate insights, investment trends, and project announcements.'
				/>
				<meta
					name='keywords'
					content='Starlife press, Real estate news, Luxury property updates, Real estate investment insights, Starlife Group announcements, Property market trends'
				/>
				<link rel='canonical' href={canonicalUrl} />
			</Helmet>

			<PressSection presses={presses} />
			{/* <GetInTouchSection /> */}
			{/* <StayConnected /> */}
		</div>
	);
}
